<template>
  <div class="MhColorSelect" :title="mPropValue" style="width: 65px">
    <el-popover placement="bottom-start" ref="popover" trigger="click" v-model="popDisabled" style="float: left">
      <div slot="reference" @click="colorSelectClick">
        <div v-if="mPropValue !== ''" class="default-style" :style="dynamicStyle"><i class="el-icon-arrow-down"></i></div>
        <div v-else class="default-style default-border"><i class="el-icon-arrow-down"></i></div>
      </div>
<!--      <div style="width: 20px; height: 20px; color: red" :class="buttonStyle(thyEffect, thyColor)" slot="reference">-->
<!--        xxxx<i class="el-icon-arrow-down"></i>-->
<!--      </div>-->
      <div class="mhcolor-list">
        <el-row class="mhcolor-options">
          <div
            class="mhcolor-options-item"
            v-for="item in tagLightColors"
            :key="item"
            @click="setThyEffectColor('light', item)"
            @dblclick="thyItemDblclick('light', item)"
            v-html="mhOptionTagCustomHtml('light', item)">
          </div>
        </el-row>
        <el-row class="mhcolor-options">
          <div
            class="mhcolor-options-item"
            v-for="item in tagDarkColors"
            :key="item"
            @click="setThyEffectColor('dark', item)"
            @dblclick="thyItemDblclick('dark', item)"
            v-html="mhOptionTagCustomHtml('dark', item)">
          </div>
        </el-row>
        <el-row class="mhcolor-options">
          <div
            class="mhcolor-options-item"
            v-for="item in tagPlainColors"
            :key="item"
            @click="setThyEffectColor('plain', item)"
            @dblclick="thyItemDblclick('plain', item)"
            v-html="mhOptionTagCustomHtml('plain', item)">
          </div>
        </el-row>
      </div>
    </el-popover>
    <div class="mhcolor-close-button" @click="colorClearClick" v-show="canClear"><i class="el-icon-circle-close"></i></div>
  </div>
</template>

<script>
import colorUtils from '../../assets/js/colors.js'
export default {
  name: 'MhColorSelect',
  // 当 model 为默认值时，可以将其省略
  model: {
    prop: 'value', // 默认是 value
    event: 'input' // 默认是 input
  },
  props: ['mProp', 'mObj', 'mReadOnly', 'mClearAble'],
  data () {
    return {
      flag: false,
      // valueArray: [],
      // valueObject: {
      //   thyEffect: '',
      //   thyColor: ''
      // },
      popDisabled: false,
      visible: false,
      thyEffect: '',
      thyColor: '',
      tagLightColors: [
        '#f75550', '#ef57ad', '#ab47bc',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffc107', '#ff9800',
        '#795548', '#607d8b', '#51565d'
      ],
      tagDarkColors: [
        '#f75550', '#ef57ad', '#ab47bc',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffc107', '#ff9800',
        '#795548', '#607d8b', '#51565d'
      ],
      tagPlainColors: [
        '#FF0000', '#FF1493', '#aa00ff',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffab00', '#ff6d00',
        '#6d4c41', '#455a64', '#212121'
      ]
    }
  },
  components: {
  },
  computed: {
    mPropValue () {
      return this.mObj[this.mProp]
    },
    dynamicStyle () {
      let bgcolor
      let borderColor
      let fontColor
      if (this.thyEffect === 'light') {
        bgcolor = colorUtils.hexToRgba(this.thyColor, 0.2)
        fontColor = '#1f2329'
        borderColor = bgcolor
      } else if (this.thyEffect === 'dark') {
        bgcolor = colorUtils.hexToRgba(this.thyColor, 1)
        fontColor = '#FFFFFF'
        borderColor = bgcolor
      } else if (this.thyEffect === 'plain') {
        bgcolor = '#FFFFFF'
        fontColor = colorUtils.hexToRgba(this.thyColor, 1)
        borderColor = fontColor
      } else {
        bgcolor = '#FFFFFF'
        fontColor = '#1f2329'
        borderColor = '#E6E6E6'
      }
      return {
        backgroundColor: bgcolor,
        color: fontColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderWidth: '1px'
        // ,
        // borderRadius: '5px'
      }
    },
    canClear () {
      if (this.mReadOnly) {
        return false
      } else {
        return this.mObj[this.mProp] !== ''
      }
    }
  },
  watch: {
    mPropValue (newVal, oldVal) {
      if (newVal !== '' && newVal.includes(';')) {
        const arr = newVal.split(';')
        this.thyEffect = arr[0]
        this.thyColor = arr[1]
      } else {
        this.thyEffect = ''
        this.thyColor = ''
      }
    }
  },
  created () {
  },
  methods: {
    buttonStyle (effect, color) {
      let bgcolor
      let borderColor
      let fontColor
      if (effect === 'light') {
        bgcolor = colorUtils.hexToRgba(color, 0.2)
        fontColor = '#1f2329'
        borderColor = bgcolor
      } else if (effect === 'dark') {
        bgcolor = colorUtils.hexToRgba(color, 1)
        fontColor = '#FFFFFF'
        borderColor = bgcolor
      } else if (effect === 'plain') {
        bgcolor = '#FFFFFF'
        fontColor = colorUtils.hexToRgba(color, 1)
        borderColor = fontColor
      } else {
        bgcolor = '#FFFFFF'
        fontColor = '#1f2329'
        borderColor = '#E6E6E6'
      }
      return {
        backgroundColor: bgcolor,
        color: fontColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    },
    setThyEffectColor (effect, color) {
      const that = this
      that.flag = true
      this.mObj[this.mProp] = [effect, color].join(';')
      console.log(this.mObj[this.mProp])
      this.buttonStyle(effect, color)
    },
    thyItemDblclick (effect, color) {
      const that = this
      that.flag = true
      this.mObj[this.mProp] = [effect, color].join(';')
      console.log(this.mObj[this.mProp])
      this.buttonStyle(effect, color)
      this.popDisabled = false
    },
    colorClearClick () {
      if ((!this.mReadOnly)) {
        this.mObj[this.mProp] = ''
      }
      console.log('colorClearClick', this.mObj[this.mProp])
    },
    colorSelectClick () {
      if ((!this.mReadOnly) && (this.mClearAble)) {
        this.popDisabled = !this.popDisabled
      }
    },
    mhOptionTagCustomHtml (effect, color) {
      let bgcolor
      let borderColor
      let fontColor
      if (effect === 'light') {
        bgcolor = colorUtils.hexToRgba(color, 0.2)
        fontColor = '#1f2329'
        borderColor = bgcolor
      } else if (effect === 'dark') {
        bgcolor = colorUtils.hexToRgba(color, 1)
        fontColor = '#FFFFFF'
        borderColor = bgcolor
      } else if (effect === 'plain') {
        bgcolor = '#FFFFFF'
        fontColor = colorUtils.hexToRgba(color, 1)
        borderColor = fontColor
      }
      const html = '<div style="' +
           'background-color: ' + bgcolor + ';' +
           'border: 1px solid ' + borderColor + ';' +
           'color: ' + fontColor + ';' +
           'width: ' + '15px;' +
           'height: ' + '15px;' +
           'border-radius: ' + '5px' +
           '"></div>'
      return html
    }
  },
  beforeMount () {
  },
  mounted () {
    document.addEventListener('click', e => {
      if (!this.$el.contains(e.target)) {
        this.popDisabled = false
      }
    })
  }
}
</script>

<style lang="less" scoped>
.mhcolor-list {
  all: initial;
  //overflow-y: scroll;//y轴显示滚动条
  //overflow-x: hidden;//x轴溢出隐藏
  //display: flex;
  //flex-wrap: wrap;//换行
  //justify-content: space-around;
  width: 100%;
  height: 100%;
  /deep/ .el-row {
    all: initial;
    padding: 0;
    margin: 0;
  }
  .mhcolor-options {
    margin: 0;
    padding: 0;
    //padding-top: 3px;
    //padding-left: 3px;
    //padding-right: 3px;
    width: 100%;
    height: 100%;
    .mhcolor-options-item {
      display: inline-block;
      line-height: 0;
      padding-left: 3px;
      padding-right: 3px;
      &:hover{
        color: deepskyblue;
        //border-color: cadetblue;
      }
    }
  }
}
.mhcolor-close-button {
  float: right;
  cursor: pointer;
  padding: 5px;
}
.default-style {
  width: 35px;
  height: 25px;
  border-radius: 5px;
  text-align: center;
  line-height: 25px;
  font-size: 15px;
  cursor: pointer
}
.default-border {
  //backgroundColor: #,
  background-color: #FFFFFF;
  color: #000000;
  border: 1px solid #E6E6E6;
}
</style>
